<script>
import {mapActions, mapGetters} from 'vuex'
export default {
	props: {
		title: {
			type: String,
			default() {
				return ''
			}
		},

		description: {
			type: String,
			default() {
				return ''
			}
		},

		activity: {
			type: Object,
			required: true,
		}
	},

	data() {
		return {
			completed: false,
			videoPlaying: false,
		}
	},

	computed: {
		...mapGetters({
			userId: 'auth/userId',
			activityCompleted: 'auth/activityCompleted'
		})
	},

	mounted() {
		const vm = this
		const $video = document.getElementById(`video_${vm._uid}`)
		$video.addEventListener('ended',this.markComplete,false)

		$(vm.$el).on('shown.bs.modal', function () {
			const video = document.getElementById(`video_${vm._uid}`)
			video.play()
		})
		$(vm.$el).on('hide.bs.modal', function () {
			const video = document.getElementById(`video_${vm._uid}`)
			if(!video) {
				return
			}
			video.pause()
			vm.$router.push({name: 'formation-index', param: {modal: ''}})
		})


	},


	methods: {
		show() {
			const vm = this
			$(vm.$el).modal('show')
			
		},
		
		hide() {
			const vm = this
			$(vm.$el).modal('hide')
		},

		markComplete() {
			const vm = this
			const $video = document.getElementById(`video_${vm._uid}`)
			$video.currentTime = 1
			this.completed = true
			this.saveProgress(Object.assign(this.activity, {completed: true, viewed: true, userId: this.userId}))
		},

		replayVideo() {
			const vm = this
			vm.completed = false
			const $video = document.getElementById(`video_${vm._uid}`)
			$video.currentTime = '0';
			$video.play();
		},

		goNextActivity() {
			this.hide()
			this.goNext(this.activity.activityId)
		},

		...mapActions({
			saveProgress: 'auth/saveUserProgress'
		})
	},

	beforeDestroy() {
		this.hide()
	}
}
</script>
<template>
	<!-- Modal -->
	<div class="modal fade" :id="`videoModal_${_uid}`" tabindex="-1"  data-keyboard="false" role="dialog" data-backdrop="static" aria-labelledby="videoModalLabel" aria-hidden="true">
		<div class="modal-dialog modal-full modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title" id="videoModalLabel">{{activity.title}}</h5>
					<button  type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<div class="video mx-n3 my-n3" :class="{'playing': videoPlaying}">
						<video :src="activity.url" class="video__src" :id="`video_${_uid}`"></video>
					</div>
					<div v-if="description">
						<p>{{ description }}</p>
					</div>
				</div>
				<div v-if="activityCompleted(activity.activityId)" class="modal-footer" :class="{completed: completed}">
					<button type="button" class="btn btn-secondary" @click="replayVideo">Repetir</button>
					<button @click="goNextActivity"  type="button" class="btn btn-primary">Siguiente</button>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss" scoped>
.video{
	position: relative;
	width: 100%;
	height: 0;
	padding-bottom: 56.25%;
	&__src {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	&.playing{
		position: fixed;
		width: 100vw;
		top: 0;
		left: 0;
	}
}
.modal-content{
	border-radius: 1rem;
	border: 0 none;
}
</style>